module.exports = __webpack_public_path__ + "static/media/1656587759_2-illustration_png.051ad67e.png";